import React from 'react'
import './section5.css'
import sec5img from './images/sec5img.png'
import { Link } from 'react-router-dom';

const section5 = () => {
  return (
    <div className='section5'>
      <div className='sec5-div'>
<div className='sec5-left'>
    <div className='sec5-left-text'>
<h2 >Start Your<span className="main">Cybersecurity Career</span> — Learn, Practice & Get Hired</h2>
<p>Cybersecurity jobs in India are growing 3x faster than any other tech role. Whether you're a fresher, a working professional, or switching careers — our hands-on training gives you the real skills. Learn cybersecurity through real attack simulations, live labs, and tools that actual security teams use — so when a threat hits, you're the one who stops it. Start today.</p>

  <Link to="/AdvanceCyberPage">
<button>Start Learning Now</button>
</Link>
</div>
</div>
<div className='sec5-right'>
<img src={sec5img} alt=''/>
</div>
      </div>
    </div>
  )
}

export default section5
